import { request } from '@/api';

//获取公告列表
export const getNoticeListApi = (params: any) => {
    return request.get('/notice/noticeList', {...params} )
}
//获取公告列表
export const getNoticeListApi2 = (params: any) => {
    return request.get('/notice/noticeList', {...params}, { showMessage: false })
}
//创建公告
export const createNoticeApi = (params: any) => {
    return request.post('/notice/createNotice', {...params})
}
//编辑草稿
export const editNoticeApi = (params: any) => {
    return request.post('/notice/editNotice', {...params})
}
//删除草稿
export const deleteNoticeApi = (params: any) => {
    return request.post('/notice/delNotice', {...params})
}
